import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "previewImage",
    "previewLabel",
    "degreeButton",
    "confirmButton",
    "degreesInput"
  ]

  static values = {
    selectedDegrees: { type: Number, default: 0 },
    suggestedDegrees: { type: Number, default: 0 }
  }

  connect() {
    // If there's a suggested rotation, pre-select it
    if (this.suggestedDegreesValue > 0) {
      this.selectDegrees(this.suggestedDegreesValue)
    }
  }

  preview(event) {
    const degrees = parseInt(event.currentTarget.dataset.degrees)
    this.selectDegrees(degrees)
  }

  selectDegrees(degrees) {
    this.selectedDegreesValue = degrees

    // Update preview image rotation
    this.previewImageTarget.style.transform = `rotate(${degrees}deg)`

    // Update preview label
    this.previewLabelTarget.textContent = `Preview (${degrees}\u00B0)`

    // Update button states
    this.degreeButtonTargets.forEach(btn => {
      const btnDegrees = parseInt(btn.dataset.degrees)
      if (btnDegrees === degrees) {
        btn.classList.remove("btn-outline")
        btn.classList.add("btn-primary")
      } else {
        btn.classList.remove("btn-primary")
        btn.classList.add("btn-outline")
      }
    })

    // Show confirm button and set the degrees in the hidden form
    this.confirmButtonTarget.classList.remove("hidden")
    this.degreesInputTarget.value = degrees
  }
}
